<template>
    <a href="/dashboard" class="title" style="align-items: center;display: flex;text-decoration: none">
        <img src="/assets/icon/icon.png" class="h-6 sm:h-9" alt="OpenCider Logo" style="width: 21px; height: 21px;margin-right: 3px">
        <span style="color: var(--ion-color-dark);font-size: 1.3rem;align-self: center;white-space: nowrap;">open<b style="color: var(--ion-color-success)">cider</b></span>
    </a>
</template>

<style>
.title {
    padding-left: 4%;
    padding-top: 0.7%;
}
    
@media screen and (max-width: 600px) {
    .title {
        padding-left: 32%;
    }
}
</style>